var s = new Map(),
  o = function o(n, t) {
    return s.set(n, t), t;
  };
export { o as illustration, s as illustrations };